import { ChatAvatar, ChatBubble } from '@zg-rentals/satellite-components';
import { Box, Icon } from '@zillow/constellation-10';
import { IconCircleFilled } from '@zillow/constellation-icons';
import { css } from '@/styled-system/css';

type Props = {
  isAiEnabledConversation: boolean;
  senderName?: string;
};

const dotPulseStyles = css.raw({
  animation: 'dotPulse 1.8s ease-in-out infinite both',
  width: '150',
  height: '150',
});

export default function TypingIndicator({ isAiEnabledConversation, senderName }: Props): JSX.Element | null {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <ChatAvatar senderFullName={senderName} type={isAiEnabledConversation ? 'bot' : 'user'} />

      <Box
        css={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 'default',
        }}
      >
        <ChatBubble variant={isAiEnabledConversation ? 'autoResponse' : 'default'}>
          <Box
            css={{
              display: 'flex',
              alignItems: 'center',
              gap: 'tightest',
              paddingBlock: 'tighter',
            }}
          >
            <Icon css={{ animationDelay: '-0.48s', ...dotPulseStyles }}>
              <IconCircleFilled />
            </Icon>
            <Icon css={{ animationDelay: '-0.24s', ...dotPulseStyles }}>
              <IconCircleFilled />
            </Icon>
            <Icon css={{ animationDelay: '0s', ...dotPulseStyles }}>
              <IconCircleFilled />
            </Icon>
          </Box>
        </ChatBubble>
      </Box>
    </Box>
  );
}
